import { config } from "@config";

export let debug: boolean = config.debug;

export function activateDebug(): void {
	debug = true;
}
